

  import '/var/www/myapp/app/webpacker/images/mobile-screenshot.jpg';

  import '/var/www/myapp/app/webpacker/images/soar/share.png';

  import '/var/www/myapp/app/webpacker/images/soar/user_experience_pedro.png';

  import '/var/www/myapp/app/webpacker/images/soar/Convidar_amigo.gif';

  import '/var/www/myapp/app/webpacker/images/soar/advantages_person.png';

  import '/var/www/myapp/app/webpacker/images/soar/comments_logo.png';

  import '/var/www/myapp/app/webpacker/images/soar/favicon.png';

  import '/var/www/myapp/app/webpacker/images/soar/home_page_figure2.png';

  import '/var/www/myapp/app/webpacker/images/soar/gmail_logo.png';

  import '/var/www/myapp/app/webpacker/images/soar/terms_page_figure1.png';

  import '/var/www/myapp/app/webpacker/images/soar/bgAuthIcon.png';

  import '/var/www/myapp/app/webpacker/images/soar/operation_group.png';

  import '/var/www/myapp/app/webpacker/images/soar/advantages_cartoon.png';

  import '/var/www/myapp/app/webpacker/images/soar/home-note.png';

  import '/var/www/myapp/app/webpacker/images/soar/operation_decision.png';

  import '/var/www/myapp/app/webpacker/images/soar/faq_disalbe.png';

  import '/var/www/myapp/app/webpacker/images/soar/operation_file.png';

  import '/var/www/myapp/app/webpacker/images/soar/comments_clock.png';

  import '/var/www/myapp/app/webpacker/images/soar/range_icon.svg';

  import '/var/www/myapp/app/webpacker/images/soar/operation_screen.png';

  import '/var/www/myapp/app/webpacker/images/soar/home_page_figure1.png';

  import '/var/www/myapp/app/webpacker/images/soar/user_experience_joao.png';

  import '/var/www/myapp/app/webpacker/images/soar/faq_red.png';

  import '/var/www/myapp/app/webpacker/images/soar/home_page_figure3.png';

  import '/var/www/myapp/app/webpacker/images/soar/sign_up_cartoon.png';

  import '/var/www/myapp/app/webpacker/images/soar/faq_page_figure1.png';

  import '/var/www/myapp/app/webpacker/images/soar/home_page_figure4.png';

  import '/var/www/myapp/app/webpacker/images/soar/Compartilhar_encontro.gif';

  import '/var/www/myapp/app/webpacker/images/soar/twitter_logo.png';

  import '/var/www/myapp/app/webpacker/images/soar/en/appStore.png';

  import '/var/www/myapp/app/webpacker/images/soar/en/googlePlay.png';

  import '/var/www/myapp/app/webpacker/images/soar/user_experience_eduarda.png';

  import '/var/www/myapp/app/webpacker/images/soar/favicon.gif';

  import '/var/www/myapp/app/webpacker/images/soar/home_page_figure5.png';

  import '/var/www/myapp/app/webpacker/images/soar/Plameet3-white.png';

  import '/var/www/myapp/app/webpacker/images/soar/Plameet2.png';

  import '/var/www/myapp/app/webpacker/images/soar/comments_wifi2.png';

  import '/var/www/myapp/app/webpacker/images/soar/PlameetFavicon.png';

  import '/var/www/myapp/app/webpacker/images/soar/avatar_default.jpg';

  import '/var/www/myapp/app/webpacker/images/soar/faq_process.png';

  import '/var/www/myapp/app/webpacker/images/soar/comments_clock1.png';

  import '/var/www/myapp/app/webpacker/images/soar/comments_wifi.png';

  import '/var/www/myapp/app/webpacker/images/soar/instagram_logo.png';

  import '/var/www/myapp/app/webpacker/images/soar/bgAuthIcon@2x.png';

  import '/var/www/myapp/app/webpacker/images/soar/temp/avatar-1.jpg';

  import '/var/www/myapp/app/webpacker/images/soar/soar.svg';

  import '/var/www/myapp/app/webpacker/images/soar/Plameet3.png';

  import '/var/www/myapp/app/webpacker/images/soar/pt-BR/appStore.png';

  import '/var/www/myapp/app/webpacker/images/soar/pt-BR/googlePlay.png';

  import '/var/www/myapp/app/webpacker/images/soar/office.png';

  import '/var/www/myapp/app/webpacker/images/soar/Criando_novo_encontro.gif';

  import '/var/www/myapp/app/webpacker/images/soar/Plameet1.png';

  import '/var/www/myapp/app/webpacker/images/soar/progress.jpg';

  import '/var/www/myapp/app/webpacker/images/soar/operation_topic.png';

  import '/var/www/myapp/app/webpacker/images/soar/advantages_group.png';

  import '/var/www/myapp/app/webpacker/images/soar/advantages_money.png';

  import '/var/www/myapp/app/webpacker/images/soar/Historico_de_encontros.gif';

  import '/var/www/myapp/app/webpacker/images/soar/site/faq/cancelar_assinatura.35d6a29eaade.png';

  import '/var/www/myapp/app/webpacker/images/soar/site/gmail.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/highlight_02.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/works_img_1.png';

  import '/var/www/myapp/app/webpacker/images/soar/site/plans_1.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/bg_comments.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/bg_works.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/insta.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/woman_01@2x.png';

  import '/var/www/myapp/app/webpacker/images/soar/site/bg_footer.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/twit.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/highlight_01.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/bg_create.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/resources_1.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/woman_04.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/aspas.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/woman_03.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/bg_bottom_create.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/temp/logo_1.png';

  import '/var/www/myapp/app/webpacker/images/soar/site/bg_top_create.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/bg_default.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/highlight_03.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/icons/icon_2.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/icons/commas.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/icons/icon_3.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/icons/icon_1.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/woman_01.png';

  import '/var/www/myapp/app/webpacker/images/soar/site/plans_2.svg';

  import '/var/www/myapp/app/webpacker/images/soar/site/woman_02.svg';

  import '/var/www/myapp/app/webpacker/images/soar/loading-gif.gif';

  import '/var/www/myapp/app/webpacker/images/soar/advantages_clock.png';

  import '/var/www/myapp/app/webpacker/images/soar/Adicionando_topicos.gif';

  import '/var/www/myapp/app/webpacker/images/soar/operation_cartoon.png';

  import '/var/www/myapp/app/webpacker/images/soar/Visualizar_todos_os_encontros_marcados.gif';

  import '/var/www/myapp/app/webpacker/images/soar/home_page_meet_example.png';

  import '/var/www/myapp/app/webpacker/images/landkit/brand.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/patterns/pattern-2.png';

  import '/var/www/myapp/app/webpacker/images/landkit/patterns/pattern-1.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-4.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-2.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-7.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-26.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-10.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-13.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-9.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-1.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-24.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-20.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-3.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-23.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-30.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-15.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-22.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-14.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-18.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-12.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-8.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-17.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-29.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-5.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-16.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-27.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-25.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-21.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-6.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-11.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-28.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/photos/photo-19.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-1.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-19.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-cover-3.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-23.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-22.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-cover-8.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-cover-7.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-8.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-5.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-14.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-cover-2.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-18.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-11.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-cover-6.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-26.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-9.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-7.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-15.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-21.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-17.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-16.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-20.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-cover-4.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-2.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-25.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-4.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-cover-1.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-12.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-6.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-cover-5.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-13.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-10.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-24.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/portfolio/portfolio-3.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/masks/avatar-group.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/masks/avatar-group-hover.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/masks/avatar-status.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/masks/avatar-group-hover-last.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-1.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-9.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-1-cropped.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-3-cropped.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-4-cropped.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-6.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-7.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-6-cropped.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-5.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-4.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-1-dark.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-3.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-8.png';

  import '/var/www/myapp/app/webpacker/images/landkit/illustrations/illustration-2.png';

  import '/var/www/myapp/app/webpacker/images/landkit/devices/iphonex.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/devices/macbook.png';

  import '/var/www/myapp/app/webpacker/images/landkit/devices/macbook.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/devices/iphonex.png';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-9.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-14.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-13.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-5.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-7.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-1.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-19.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-11.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-6.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-8.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-2.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-18.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-3.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-10.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-15.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-12.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-16.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-17.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/covers/cover-4.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/buttons/button-app.png';

  import '/var/www/myapp/app/webpacker/images/landkit/buttons/button-play.png';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/security-code.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/amex.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/paypal.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/visa.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/unionpay.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/elo.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/discover.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/mastercard-old.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/verve.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/mastercard.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/default.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/diners.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/jcb.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/maestro-old.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/maestro.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/alipay.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/payment-methods/hipercard.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/figma-dark-circle.png';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/social/instagram.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/social/linkedin.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/social/pinterest.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/social/facebook.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/icons/social/twitter.svg';

  import '/var/www/myapp/app/webpacker/images/landkit/avatars/avatar-3.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/avatars/avatar-2.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/avatars/avatar-1.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/avatars/avatar-4.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/avatars/avatar-5.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/figma.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/portfolio-sidebar.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/terms.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/blog-rich.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/contact-alt.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/career.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/portfolio-parallax.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/blog-showcase.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/pricing.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/portfolio-grid-rows.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/blog-search.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/portfolio-sidebar-fluid.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/contact.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/portfolio-basic-grid.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/blog-post.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/help-center.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/about.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/help-center-article.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/career-listing.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/portfolio-masonry.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/pages/portfolio-case-study.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/jobs.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/coworking.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/rental.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/cloud.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/homepage.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/mobile.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/agency.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/desktop.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/framework.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/enterprise.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/startup.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/landing/service.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signup-modal-vertical.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signin-illustration.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/general.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/error-cover.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signup.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/error-illustration.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/security.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signup-cover.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signin.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/password-reset-cover.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/plans-and-payments.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/password-reset.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signup-modal-horizontal.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signin-modal-horizontal.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/notifications.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signin-cover.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signin-modal-vertical.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/signup-illustration.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/users.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/error.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/landkit/account/password-reset-illustration.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/ui/analytics-2.png';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/ui/mobile-chat.png';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/ui/analytics-1.png';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/ui/analytics-3.png';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/ui/dashkit-layered.png';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/ui/landkit-figma.png';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/desktop/jobs.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/desktop/rental.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/desktop/dashkit-alt-dark.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/desktop/dashkit-alt.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/desktop/dashkit.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/desktop/dashkit-alt-mixed-cropped.png';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/mobile/jobs.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/mobile/rental.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/mobile/home.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/mobile/dashkit-alt.jpg';

  import '/var/www/myapp/app/webpacker/images/landkit/screenshots/mobile/dashkit.jpg';

  import '/var/www/myapp/app/webpacker/images/proposito-logo-horizontal-color-768x132.png';

  import '/var/www/myapp/app/webpacker/images/proposito-logo-horizontal-white-768x132.png';
